import React from 'react';
import InfoList from './components/infoList';
import './styles/infoStyle.css';

export default function Info({ data, title, subtitle }) {
  return (
    <div>
      <div className="info-container">
        <h3 className="info-title">{title}</h3>
        <h2 className="info-subtitle">{subtitle}</h2>
        {data.map(list =>
          <InfoList data={list} key={list.content} />
        )}
      </div>
    </div>
  )
}